import { apiInstance_ecom } from "@/app/api-config/axios-instance";

class ServiceBase {
  async _handleAPICall(
    endpoint,
    params = {},
    method = "get",
    useParamsAsQueryString = false,
    skipLoader = true
  ) {
    try {
      const config = { skipLoader };
      let payload;

      if (useParamsAsQueryString) {
        config.params = params;
        // payload = {};
      } else {
        payload = params;
      }

      const response = await apiInstance_ecom({
        method,
        url: endpoint,
        data: payload,
        ...config,
      });

      if (response.status >= 200 && response.status < 300) {
        return response.data;
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error("API call error:", error.message);
      throw error; // Re-throw the error for the caller to handle
    }
  }
}

export default ServiceBase;
